// extracted by mini-css-extract-plugin
export default {"auth-form":"resetPassword_auth-form__0of71"};